// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__2aWP3","ScrollX":"Scroll_ScrollX__ltv13","ScrollY":"Scroll_ScrollY__cQgLs"};